export enum DEALER_KEYS {
  ACCEPTED_MAINTENANCE_NOTIFICATION_KEY = 'acceptedDealerMaintenanceNotification',
  MODAL_CHANGE = 'dealerModalChange',
  PREFERRED_CHANGED = 'preferredDealerChanged',
  PREFERRED_KEY = 'dealer'
}
